import { authFetchGET } from '../utils/auth-fetch';

const env = (<any>window).appenv;

export interface Prediction
{
    Height: number;
    DateTime: string;
}

export type StationType = "Port" | "Stream";

export interface Station
{
    area: string;
    id: string;
    latitude: number;
    licensed: boolean;
    longitude: number;
    name: string;
    type: StationType;
}

export class TidesService {
    static async fetchAllStations() : Promise<Station[]> {
        return await authFetchGET(env.scope, `${env.services.tides.baseurl}/stations`);
    }

    static async getPredictionsRange(stationId: string, startDateUTC: string, endDateUTC: string): Promise<Prediction[]> {
        const result = await authFetchGET(env.scope, `${env.services.tides.baseurl}/predictions/${stationId}/${startDateUTC}/${endDateUTC}`);
        return result;
    }

    static async getPredictionAtTime(stationId: string, dateTime: Date): Promise<Prediction>
    {
        const result = await authFetchGET(env.scope, `${env.services.tides.baseurl}/predictions/${stationId}/${dateTime.toISOString()}`);
        return result;
    }

    static async getCurrentPrediction(stationId: string): Promise<Prediction>
    {
        const result = await authFetchGET(env.scope, `${env.services.tides.baseurl}/predictions/${stationId}`);
        return result;
    }

    static async getPredictionsRangeWithInterval(stationId: string, startDateUTC: string, endDateUTC: string, interval: number): Promise<Prediction[]> {
        const result = await authFetchGET(env.scope, `${env.services.tides.baseurl}/predictions/${stationId}/${startDateUTC}/${endDateUTC}/${interval}`);
        return result;
    }
}